module.exports = __webpack_public_path__ + "static/0021-d5e304645073d7b7ec00af0fedffc3be.png";